import React, { useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Download, X } from "lucide-react";
import { toast } from "sonner";

export function AnteprimaPdf({ open, onClose, url, titolo }) {
  const [blobUrl, setBlobUrl] = useState(null);
  const [nome, setNome] = useState("documento.pdf");

  useEffect(() => {
    if (!open || !url) return undefined;
    let revoke = null;
    api.get(url.startsWith(API) ? url.slice(API.length) : url, { responseType: "blob" })
      .then((res) => {
        const m = /filename="?([^";]+)"?/.exec(res.headers["content-disposition"] || "");
        if (m) setNome(decodeURIComponent(m[1]));
        revoke = URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
        setBlobUrl(revoke);
      })
      .catch(() => toast.error("Impossibile caricare l'anteprima"));
    return () => { if (revoke) URL.revokeObjectURL(revoke); setBlobUrl(null); };
  }, [open, url]);

  const scarica = () => {
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = nome;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-[96vw] w-[96vw] h-[94vh] p-0 flex flex-col gap-0" data-testid="anteprima-pdf-dialog">
        <DialogHeader className="px-4 py-3 border-b flex-row items-center justify-between space-y-0">
          <div>
            <DialogTitle className="font-display text-base">{titolo}</DialogTitle>
            <DialogDescription className="text-xs">Controlla il documento prima di stamparlo o inviarlo.</DialogDescription>
          </div>
          <div className="flex items-center gap-2 mr-6">
            <Button size="sm" onClick={scarica} disabled={!blobUrl} data-testid="anteprima-pdf-scarica"><Download className="h-4 w-4 mr-1.5" /> Scarica / Stampa</Button>
            <Button size="sm" variant="outline" onClick={onClose} data-testid="anteprima-pdf-chiudi"><X className="h-4 w-4" /></Button>
          </div>
        </DialogHeader>
        <div className="flex-1 bg-slate-100">
          {blobUrl ? (
            <iframe title={titolo} src={blobUrl} className="w-full h-full" data-testid="anteprima-pdf-iframe" />
          ) : (
            <div className="h-full flex items-center justify-center text-slate-400">Caricamento anteprima…</div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
